import { render } from "./WaitlistRewards.vue?vue&type=template&id=22ba5f33&scoped=true"
import script from "./WaitlistRewards.vue?vue&type=script&lang=js"
export * from "./WaitlistRewards.vue?vue&type=script&lang=js"

import "./WaitlistRewards.vue?vue&type=style&index=0&id=22ba5f33&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ba5f33"]])

export default __exports__